import { call, getFileContent, METHODS } from '../http-client';

const ROUTE_PREFIX = 'promotion-campaigns';

export const getPromotionCampaigns = async (params = {}) => {
    let qs = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if(value !== undefined){
            if(Array.isArray(value)){
                value.forEach(v => qs.append(key, v));
            }
            else {
                qs.append(key, value);
            }
        }
    });

    try {
        return await call(METHODS.GET, ROUTE_PREFIX, `?${qs.toString()}`);
    } catch (e) {
        console.error(`getPromotionCampaigns error: ${e.message}`);
        throw e;
    }
};

export const getPromotionCampaign = async (campaignId) => {
    try {
        return await call(METHODS.GET, ROUTE_PREFIX, `${campaignId}`);
    } catch (e) {
        throw e;
    }
};


export const updatePromotionCampaign = async (campaignId, data) => {
    try {
        return await call(METHODS.PATCH, ROUTE_PREFIX, `${campaignId}`, data);
    } catch (e) {
        console.error(`updatePromotionCampaign error: ${e.message}`);
        throw e;
    }
};


export const updatePromotionCampaignPromotions = async (campaignId, data) => {
    try {
        return await call(METHODS.PATCH, ROUTE_PREFIX, `${campaignId}/promotions`, data);
    } catch (e) {
        console.error(`updatePromotionCampaign error: ${e.message}`);
        throw e;
    }
};

export const updatePromotion = async (campaignId, promotionId, data) => {
    try {
        return await call(METHODS.PATCH, ROUTE_PREFIX, `${campaignId}/${promotionId}`, data);
    } catch (e) {
        console.error(`updatePromotion error: ${e.message}`);
        throw e;
    }
};

export const exportCampaignSales = async (campaignId) => {
    try {
        return await call(METHODS.GET, `${ROUTE_PREFIX}/${campaignId}/export`)
    } catch (e) {
        console.error(`exportCampaignSales error: ${e.message}`);
        throw e;
    }
};
